export type AddressDeterminantsModel = {
  is_generic_unit: boolean;
  is_private_unit: boolean;
  is_listable_unit: boolean;
  is_unit_type: boolean;
  address_line_1: string;
  address_line_2: string | null;
  unit_name: string | null;
  property_name: string | null;
  city: string | null;
  state: string | null;
  postal_code: string | null;
};

export type FormatUnitAddressOptions = {
  /** @default false */
  includePostalCode?: boolean;
};

/**
 * Returns formatted addresses for units in our system
 */
export function formatUnitAddress(
  {
    is_generic_unit,
    is_unit_type,
    property_name,
    address_line_1,
    address_line_2,
    unit_name,
    city,
    state,
    postal_code,
  }: AddressDeterminantsModel,
  options?: FormatUnitAddressOptions
): string | null {
  if (is_generic_unit) return null;

  let result = '';

  const complement = unit_name || address_line_2;

  if (is_unit_type && property_name && complement) {
    result = `${property_name}, ${complement}`;
  } else if (complement) {
    result = `${address_line_1}, ${complement}`;
  } else {
    result = address_line_1;
  }

  if (result && city) {
    result += `, ${city}`;
  }

  if (result && state) {
    result += `, ${state}`;
  }

  if (result && (city || state) && options?.includePostalCode && postal_code) {
    result += ` ${postal_code}`;
  }

  return result || null;
}
